import { lazy, Suspense, type ComponentProps } from "react";

const NotebookEditor = lazy(() => import("./NotebookEditor"));

function EditorSkeleton() {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="border-b p-2 flex gap-1 bg-muted/50">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="h-8 w-8 rounded bg-muted/60 animate-pulse" />
        ))}
      </div>
      <div className="p-4 min-h-[400px]">
        <div className="space-y-2">
          <div className="h-4 w-3/4 rounded bg-muted/40 animate-pulse" />
          <div className="h-4 w-full rounded bg-muted/40 animate-pulse" />
          <div className="h-4 w-5/6 rounded bg-muted/40 animate-pulse" />
        </div>
      </div>
    </div>
  );
}

export default function LazyNotebookEditor(props: ComponentProps<typeof NotebookEditor>) {
  return (
    <Suspense fallback={<EditorSkeleton />}>
      <NotebookEditor {...props} />
    </Suspense>
  );
}
